import { render, staticRenderFns } from "./adsModal.vue?vue&type=template&id=3a0ad4f5"
import script from "./adsModal.vue?vue&type=script&lang=js"
export * from "./adsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports